<template>
  <transition name="fade">
    <section class="popup">
      <template v-if="activeIcon">
        <svg class="icon" aria-hidden="true"
          style="width: 1.5rem; height: 1.5rem">
          <use :xlink:href='activeIcon'></use>
        </svg>
      </template>
      <div class="msg" :style="{ 'width': activeIcon?'':'100%' }" v-text="popupText"></div>
    </section>
  </transition>
</template>
<script>
  export default {
    name: 'popupModal',
    data() {
      return {
        timer: null,
        duration: 3000,
        popupText: '',
        activeIcon: '',
      };
    },
    created() {
      const duration = Number.isNaN(this.duration) ? 3000 : this.duration;
      this.timer = setTimeout(this.close, duration);
    },
    methods: {
      close() {
        clearTimeout(this.timer);
        // 销毁组件
        if (typeof this.onClose === 'function') {
          this.onClose(this);
        }
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      },
    },
  }
</script>
<style lang="stylus" scoped>
  .fade-enter-active, .fade-leave-active 
    transition: opacity .5s

  .fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */
    opacity: 0

  .el-icon-close
    cursor: pointer;

  .popup
    z-index: 4001;
    height: 3rem;
    width: 18rem;
    text-align: center
    position: relative;
    left: 50%
    bottom: 90%
    background-color: #8b8b8bbd
    transform: translate(-50%, -50%)
    display: flex
    border-radius: 0.375rem
    align-items: center

    .icon 
      margin-left auto
      margin-right 4px
    .msg
      margin-right auto 
      font-size 16px
      color #FFFEFE
</style>




// WEBPACK FOOTER //
// src/components/oneToOne/popupModal/src/popupModal.vue